// extracted by mini-css-extract-plugin
module.exports = {"root":"ReviewsRating_root__9q9dK","small":"ReviewsRating_small__JSfk3","link":"ReviewsRating_link__2fSKe","pointer":"ReviewsRating_pointer__ZT_wV"};